export const serializeSearchParams = <T extends Record<string, unknown>>(
  search: T
): Record<string, string> => {
  const newSearch: Record<string, string> = {};
  Object.entries(search).forEach(([key, value]) => {
    if (value) {
      newSearch[key] = typeof value === "string" ? value : JSON.stringify(value);
    }
  });

  return newSearch;
};